import React from 'react';
import { Provider } from 'react-redux';
import store from '../../../store';
import BaseControl from '../common/BaseControl';
import GPSPlayer from './GPSPlayer';
import ReplayContext from './ReplayContext';
import ReplayBox from './ReplayBox';
import { setActiveControl } from '../common/ControlBox';

export default class ReplayControl extends BaseControl {
    constructor(map, google) {
        super(map, google);
        this.controlBox = null;
        this.gpsPlayer = null;
        this.mapMarker = null;
        this.replayEGListControl = null;
        this.controlName = "replay";

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.setMapMarker = this.setMapMarker.bind(this);
        this.setReplayEGListControl = this.setReplayEGListControl.bind(this)
    }

    setReplayEGListControl(instance) {
        this.replayEGListControl = instance;
    }

    setMapMarker(markerObj) {
        this.mapMarker = markerObj;
        return this;
    }

    open() {
        if (!this.controlBox) this.controlBox = this.map.getControlBox(this.google.maps.ControlPosition.BOTTOM_CENTER);
        if (this.controlBox.getControl(this.controlName)) return;

        this.gpsPlayer = new GPSPlayer(this.map, this.google);
        if (this.replayEGListControl) this.replayEGListControl.setGPSPlayer(this.gpsPlayer);

        this.controlBox.add({
            name: this.controlName, index: 1, className: "map-replay-control",
            component:
                (<Provider store={store}>
                    <ReplayContext.Provider
                        value={{
                            gpsPlayer: this.gpsPlayer,
                            mapMarker: this.mapMarker,
                            onClose: this.close
                        }}>
                        <ReplayBox replayEGListControl={this.replayEGListControl}/>
                    </ReplayContext.Provider>
                </Provider>)
        });
        setActiveControl("ctlReplay", true);
    }

    close() {
        if (this.gpsPlayer) {
            this.gpsPlayer.dispose();
            this.gpsPlayer = null;
        }
        if (this.controlBox) this.controlBox.remove(this.controlName);
        if (this.replayEGListControl) this.replayEGListControl.close();
        if (this.mapMarker) this.mapMarker.showMarkers();
        setActiveControl("ctlReplay", false);
    }
}